module.exports = __webpack_public_path__ + "static/step-3.274d74f5.png";